import React from "react";
import { Layout } from "antd";
import "./FooterNav.css";

const { Footer } = Layout;

export default function FooterNav() {
  return <Footer> Andre Chen 2020</Footer>;
}
